require('./audio-waves.component.scss');

const MEDIA_ERR_ABORTED = 1; // fetching process aborted by user
const MEDIA_ERR_NETWORK = 2; // error occurred when downloading
const MEDIA_ERR_DECODE = 3; // error occurred when decoding
const MEDIA_ERR_SRC_NOT_SUPPORTED = 4; // audio/video not supported

const MEDIA_ERROR_CODE = {
  '1': gettext('Отменено'),
  '2': gettext('Ошибка сети'),
  '3': gettext('Ошибка кодека'),
  '4': gettext('Не поддерживается'),
};

/*@ngInject*/
class AudioWavesController {
  constructor(
    $scope,
    $http,
    $element,
    $timeout,
    LayoutService,
    AudioWavesService,
    AudioViewerService,
  ) {
    this.$http = $http;
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.layout = LayoutService;
    this.AudioWavesService = AudioWavesService;
    this.AudioViewerService = AudioViewerService;
    this.currentTime = 0;
    this._duration = 0;
    this.audioErrors = MEDIA_ERROR_CODE;
    this.playing = false;
    this.$showTimeRange = true;
    this.loading = false;

    // error occurred during the loading or playing
    $scope.$on('col-resize', () => {
      this.onResize();
      this.$scope.$digest();
    });
    $scope.$on('resize', () => this.onResize());
    $scope.$on('splitter1Changed', () => this.onResize());

    this.$scope.$on('wavesurferInit', () => this.wavesurferInit());
    // this.$scope.$on('wavesurferReady', () => this.loading = false);

    this.onError = (err) => {
      if (err) {
        console.error(err, this.waveSrc);
        this.error = `${err}, src: ${this.waveSrc}`;
      }
      this.playing = false;
      $scope.$digest();
    };

    // the audio has been started or is no longer paused
    this.onPlay = () => {
      // console.log('onPlay CurrentTime:', this.fact.wavesurfer.getCurrentTime());
      this.playing = true;
      this.AudioWavesService.stopped = false;
      if (!$scope.$root.$$phase) $scope.$digest();
    };

    // the audio has been paused
    this.onPause = () => {
      // console.log('onPause CurrentTime:', this.fact.wavesurfer.getCurrentTime());
      this.playing = false;
      this.AudioWavesService.stopped = true;
    };


    // the audio is ended
    this.onEnded = () => {
      if (!this.fact.wavesurfer) return;
      if (!this.fact.wavesurfer.getCurrentTime()) return;
      this.playing = false;
      this.AudioViewerService.playNextAudio(this.fact.id);
    };

    // duration data is changed
    this.onDurationChange = () => {
      this.updateDuration();

    };

    // position is changed
    this.onTimeUpdate = () => {
      this.updateCurrentTime();
      $scope.$digest();
    };

    this.$element.ready(() => {
      this.setScrollElement();
    });
  }

  setScrollElement() {
    this.$timeout(() => {
      this.scrollElement = this.$element.closest('[infinite-scrollfork]');
    }, 20);
  }

  get fullSrc() {
    return this.AudioWavesService.getSrcType(this.src, this.AudioWavesService.downloadType);
  }

  get waveSrc() {
    return this.AudioWavesService.getSrcType(this.src, this.AudioWavesService.waveType);  // any not .wma types
  }

  get fileName() {
    return `${this.fact['agent_agent.computer_name']}_${
      this.fact.local_time.substring(0, 19).replace(/:/gi, '').replace(/T/gi, '_')
    }.${this.AudioWavesService.downloadType}`;
  }

  reload() {
    if (this.reloading) {
      return;
    }
    this.reloading = true;
  }

  reloadAudio() {
    if (!this.fact.wavesurfer) return;
    // console.log('reloadAudio CurrentTime:', this.fact.wavesurfer.getCurrentTime());
    this.fact.wavesurfer.load(this.waveSrc);
    this.updateDuration();
    this.updateCurrentTime();
    this.reloading = false;
  }

  $onInit() {
    // this.createAudio();
  }

  $onDestroy() {
    this.disposeAudio();
  }

  wavesurferInit() {
    this.fact.wavesurfer.on('audioprocess', this.onTimeUpdate);
    this.fact.wavesurfer.on('error', this.onError);
    this.fact.wavesurfer.on('play', this.onPlay);
    this.fact.wavesurfer.on('pause', this.onPause);
    this.fact.wavesurfer.on('finish', this.onEnded);
    this.fact.wavesurfer.on('seek', this.onTimeUpdate);
    this.fact.wavesurfer.on('ready', this.onWavesurferReady.bind(this));
  }

  onWavesurferReady() {
    this.updateDuration();
    this.$scope.$digest();
  }

  disposeAudio() {
    if (this.fact.wavesurfer && this.fact.wavesurfer.isPlaying()) this.fact.wavesurfer.pause();
  }

  play() {
    if (!this.fact.wavesurfer) return;
    this.AudioViewerService.play(this.fact);
    this.fact.audioLoad = true;
  }

  get isPlaying() {
    return this.fact.wavesurfer && this.fact.wavesurfer.isPlaying();
  }

  get duration() {
    if (!this._duration) this.updateDuration();
    return this._duration;
  }

  updateDuration() {
    if (!this.fact.wavesurfer) return;
    const duration = this.fact.wavesurfer.getDuration();
    this._duration = Math.floor(duration);
  }

  updateCurrentTime() {
    if (!this.fact.wavesurfer) return;
    this.currentTime = Math.floor(this.fact.wavesurfer.getCurrentTime());
  }

  get downreloadSrc() {
    return this.AudioWavesService.getSrcType(
      this.src,
      this.AudioWavesService.downloadType,
    );
  }

  onResize() {
    if (!this.fact.wavesurfer) return;
    this.$showTimeRange = this.$element.parent().width() > 280;
    this.fact.wavesurfer.drawBuffer();
  }

  get showTimeRange() {
    return this.$showTimeRange;
  }

  get showTime() {
    return this.playing || this.isSelected && this.hasDuration;
  }

  get isSelected() {
    return this.fact.selected;
  }

  get hasDuration() {
    if (!this.fact.wavesurfer) return false;
    const duration = this.fact.wavesurfer.getDuration();

    return typeof duration === 'number' &&
      !isNaN(duration) && isFinite(duration);
  }

  get isShowWaves() {
    return this.fact.selected || this.$element.closest('.show-waves')[0] ||
      (!this.$element.closest('sc-fact-thumb')[0] && this.scrollElement &&
        this.scrollElement[0] && this.$element.offset().top + 200 > 0 &&
        this.$element.offset().top - 200 < this.scrollElement.height() &&
        this.$element.offset().left + 200 > 0 &&
        this.$element.offset().left - 200 < this.scrollElement.width()
      );
  }
}

export const AudioWavesComponent = {
  template: require('./audio-waves.component.html'),
  controller: AudioWavesController,
  bindings: {
    fact: '<',
    src: '<',
    index: '<'
  },
};



// WEBPACK FOOTER //
// ./src/facts/audio-waves/audio-waves.component.js